/** @format */

import {Button, Input, Select} from '@sttark/design-system';
import {AddressesList} from './addresses_list';
import UserAccountAddressForm from './form';
import {Toast} from '@sttark/design-system';
import React, {useState} from 'react';

// styles
import './addresses_tab.scss';

const options = [
    {
        value: 'address',
        label: 'Address'
    },
    {
        value: 'name',
        label: 'Name'
    },
    {
        value: 'company',
        label: 'Company'
    },
    {
        value: 'phone',
        label: 'Phone'
    },
    {
        value: 'email',
        label: 'Email'
    }
];
export const AddressesTab = props => {
    const {isShippingAddress = false} = props;

    const [searchFilterKey, setSearchFilterKey] = useState('Address');
    const [isEditingAddress, setIsEditingAddress] = useState(false);
    const [searchFilterValue, setSearchFilterValue] = useState('');
    const [refetchResults, setRefetchResults] = useState(0);
    const [isToastOpen, setIsToastOpen] = useState(false);

    const handleSearchFilterKeyChange = key => {
        setSearchFilterKey(key);
    };

    const titleLabel = isShippingAddress ? 'Shipping' : 'Billing';

    return (
        <div className="billing-tk04">
            <Toast
                onClose={() => setIsToastOpen(false)}
                autoHideDuration={4000}
                isOpen={isToastOpen}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">Address saved successfully</p>
            </Toast>
            <UserAccountAddressForm
                onClose={() => setIsEditingAddress(false)}
                isShippingAddress={isShippingAddress}
                onSaveComplete={() => {
                    setRefetchResults(refetchResults + 1);
                    setIsEditingAddress(false);
                    setIsToastOpen(true);
                }}
                isOpen={isEditingAddress}
            />
            <div className="user-shipping-addresses-18lc__header">
                <h3 className="m-0 p-0">Manage {titleLabel} Addresses</h3>
            </div>

            <div className="view-add-05kt__contianer">
                <div className="d-flex align-items-end justify-content-center w-100 mb-4">
                    <div className="view-add-05kt-contianer__form-select">
                        <h5>Search By</h5>
                        <Select
                            className="view-add-05kt__select m-0"
                            onChange={handleSearchFilterKeyChange}
                            placeholder="Select Payment method"
                            initialValue={searchFilterKey}
                            value={searchFilterKey}
                            options={options}
                            label=""
                        />
                    </div>
                    <div className="view-add-05kt-contianer__form-input">
                        <h5>Search By</h5>
                        <Input
                            onChange={val => setSearchFilterValue(val)}
                            className="view-add-05kt__input w-100"
                            placeholder="Search addresses"
                            value={searchFilterValue}
                            label=""
                        />
                    </div>
                    <Button
                        className="flex-shrink-0 btn btn--primary py-1 view-add-05kt__btn"
                        onClick={() => setIsEditingAddress(true)}
                        label="Add An Address"
                        primary
                        small
                    />
                </div>
                <AddressesList
                    isShippingAddress={isShippingAddress}
                    filterableValue={searchFilterValue}
                    filterableKey={searchFilterKey}
                    refetch={refetchResults}
                />
            </div>
        </div>
    );
};
